// extracted by mini-css-extract-plugin
module.exports = {"toggleTimer":"timer-toggle_toggleTimer__rQtbC","cimPosition":"timer-toggle_cimPosition__s3njL","toggleTimerButton":"timer-toggle_toggleTimerButton__Sdbvq"};